/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Collaboration
 * (C) Copyright IBM Corp. 2018, 2022
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define('collaboration/messaging/connectors/msteams/MSTeamsAuth',['../../../lib/@waca/core-client/js/core-client/ui/core/Class', '../../utils/PopupWindow', '../../../nls/StringResources'], function (Class, PopupWindow, StringResources) {
	'use strict';

	var AUTH_URL_TEMPLATE = 'https://login.microsoftonline.com/{namespaceId}/oauth2/v2.0/authorize?client_id={clientId}&response_type=code&redirect_uri={redirectUri}&response_mode=query&state={state}&scope=offline_access chat.create user.read.all directory.read.all channelMessage.send channelSettings.read.all group.read.all groupMember.read.all chatMember.read chatMessage.Send chat.readBasic';
	var REDIRECT_URI = '/v1/collaboration/auth/msteams';
	var WINDOW_W = 720;
	var WINDOW_H = 580;

	var MSTeamsAuth = Class.extend( /** @lends MSTeamsAuth */{

		/**
   * @desc Constructor for MSTeamsAuth.
   * @constructs MSTeamsAuth
   * @extends Class
   * @public
   * @param {object} glassContext - the Glass context, mandatory
   * @returns an object for MS Teams authentication operations
   * @example var msTeamsAuth = new MSTeamsAuth(glassContext);
   */
		init: function init(glassContext) {
			MSTeamsAuth.inherited('init', this, arguments);
			this.glassContext = glassContext;
		},

		getRedirectUrl: function getRedirectUrl(location) {
			var origin = location.origin || location.protocol + '//' + location.host;
			var pathname = location.pathname || '';
			if (pathname.lastIndexOf('/') !== -1) {
				pathname = pathname.substring(0, pathname.lastIndexOf('/'));
			}
			return origin + pathname + REDIRECT_URI;
		},

		/**
   * Authenticates the user in MS Teams.
   * @instance
   * @returns {object} a JSON object
   */
		authWithTeams: function authWithTeams(options) {
			var coords = PopupWindow.center(WINDOW_W, WINDOW_H);
			var uri = this.getRedirectUrl(window.location);
			var resolved = false;

			options.redirectUri = uri;
			options.state = options._id + '|' + options.redirectUri;
			var authUrl = AUTH_URL_TEMPLATE.replace(/\{([A-Za-z]+)\}/g, function (match, param) {
				return encodeURIComponent(options[param]) || '';
			});

			return new Promise(function (resolve, reject) {
				window.addEventListener('message', function (event) {
					// Fix COLLAB-1642: Verify the message's origin in this cross-origin communication.
					if (event.origin !== window.location.protocol + '//' + window.location.hostname && event.origin !== window.location.origin) {
						// When receiving the message from an unverified sender. That's an error.
						var error = new Error(StringResources.get('error_auth_failure_generic'));
						error.code = 'invalid_sender';
						reject(error);
					}
					try {
						resolve(JSON.parse(event.data));
						resolved = true;
					} catch (error) {
						// parse can fail parsing the json
						console.error(error);
					}
				}, {
					once: true
				});

				window.msteamsAuthCallback = function (data) {
					try {
						resolve(JSON.parse(data));
						resolved = true;
					} catch (error) {
						// parse can fail parsing the json
						console.error(error);
					}
				};

				var success = PopupWindow.open(authUrl, 'MSTeamsAuth', ['width=' + WINDOW_W, 'height=' + WINDOW_H, 'top=' + coords.top, 'left=' + coords.left, 'scrollbars=yes', 'resizable=yes', 'status=yes'].join(','), function () {
					if (!resolved) {
						// The popup window was been closed without being resolved. That's an error.
						var error = new Error(StringResources.get('error_auth_failure_generic'));
						error.code = 'auth_closed';
						reject(error);
					}
				});
				if (!success) {
					// The popup window could not be opened. That's an error.
					var error = new Error(StringResources.get('error_popup_window'));
					error.code = 'no_popup_window';
					reject(error);
				}
			});
		}
	});
	return MSTeamsAuth;
});
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}
}();

;

